module.exports = __webpack_public_path__ + "static/media/logo3.a033f287.png";